define('views/blocks/checkout/VoucherCheckoutDialogView',['jquery','views/blocks/checkout/CheckoutDialogView','app','template!blocks/checkout/dialog-voucher'],
    function ($,CheckoutDialogView,app,dialogVoucherTemplate) {

        //
        // représente le bloc bon de réduction
        //

        return CheckoutDialogView.extend({
            getInner:function(){
                return dialogVoucherTemplate();
            },
            afterIntro:function(){
                // autofocus
                if(!Modernizr.touchevents){
                    this.$('.input').focus();
                }
            },
            submit:function(){
                var view = this,btn = view.$('.btn-submit'),
                    cart = app.getCart(),
                    voucherCode = view.$('.input').val();
                function ButtonLoader(init){
                    btn.prop('disabled',init===true).toggleClass('loading',init===true);
                }
                function StopListening(){
                    view.stopListening(app,'addVoucher',AddVoucher);
                    view.stopListening(app,'cancelVoucher',CancelVoucher);
                }
                function AddVoucher(){
                    StopListening();
                    view.close();
                }
                function CancelVoucher(){
                    StopListening();
                    ButtonLoader(false);
                }
                ButtonLoader(true);
                view.listenToOnce(app,'addVoucher',AddVoucher);
                view.listenToOnce(app,'cancelVoucher',CancelVoucher);
                cart.addVoucher(voucherCode);
                return false;
            }
        });
    });
